export enum LegendType {
  STOP_INFO = 'stopInfo',
  STOPS = 'stops',
  AFFECTED_RESERVATIONS = 'affectedReservations',
  TIMES = 'times'
}